jQuery.fn.slimSelect = function (f?: (v: string)=>any) {
    for(const el of Array.from(this)){
        if(el.tagName !== 'SELECT') continue;
        const d = slimCustom.apply(el as HTMLSelectElement, [f]);
        new SlimSelect({
            searchFilter(o: {text: string}, s: string) {
                const text = o.text.toLowerCase()
                    .replace(/[ёэ]/g, 'е')
                    .replace(/[^а-яa-z0-9]/g, '');
                const search = s.toLowerCase()
                    .replace(/[ёэ]/g, 'е')
                    .replace(/[^а-яa-z0-9]/g, '');
                return text.indexOf(search) !== -1;
            },
            showSearch: el.children.length > 10,
            ...d
        })
    }
    return this;
};
export function slimCustom(this: HTMLSelectElement, f?: (v: string)=>any) {
    const t = $(this),
        d:SlimSelectParams = {
            select: this,
            searchPlaceholder: 'Искать',
            searchText: 'Ничего не найдено',
            placeholder: (t.data('placeholder') || 'Поиск...'),
            showContent: t.data('direction') || 'down',
        }
    if (window.screen.width <= 768) {
        if (this.multiple) {
            d.allowDeselectOption = true;
            d.closeOnSelect = false;
        }
        d.beforeOpen = function () {
            // this.select.element.style.display = "block"
            document.body.style.overflow = 'hidden';
        }
        d.beforeClose = function () {
            // this.select.element.style.display = "none"
            document.body.style.overflow = '';
        }
    }
    if (t.data('addable')) {
        d.addable = f || ((val:any)=>val);
    }
    return d
}

